import { render, staticRenderFns } from "./SATs.vue?vue&type=template&id=96236f58&scoped=true"
import script from "./SATs.vue?vue&type=script&lang=js"
export * from "./SATs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96236f58",
  null
  
)

export default component.exports